import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ErrorIcon } from '../../../icons/ErrorIcon';
import DialecticaLogoWithText from '../../../icons/DialecticaLogoWithText';

const GridContainer = styled(Grid)({
  justifyContent: 'space-between',
});

const StyledLogo = styled(DialecticaLogoWithText)(({ theme }) => ({
  width: '284px',
  height: '284px',
  [theme.breakpoints.down('md')]: {
    width: '200px',
    height: '200px',
  },
}));

export function GetStarted() {
  const { nextPane, state } = useAppStateContext();

  return (
    <Container>
      <GridContainer container alignItems="center">
        <Grid item lg={5}>
          {state.appIsExpired ? (
            <>
              <Typography variant="h1" gutterBottom>
                <ErrorIcon />
                App has expired.
              </Typography>

              <Typography variant="body1" gutterBottom>
                Please re-deploy the application and try again.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h1" gutterBottom>
                Let's get started.
              </Typography>

              <Typography variant="body1" gutterBottom>
                We'll help you solve any video troubles you're experiencing but first, let's check your setup.
              </Typography>
            </>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={nextPane}
            style={{ marginBottom: '1em' }}
            disabled={state.appIsExpired}
          >
            Get started
          </Button>
        </Grid>

        <Grid item lg={5}>
          <StyledLogo />
          <Typography variant="body1" color="textSecondary" gutterBottom>
            <strong>Not sure about something?</strong> Skip that section for now, and your support administrator can
            help later.
          </Typography>
        </Grid>
      </GridContainer>
    </Container>
  );
}
